import FooterLogoIcon from '../../assets/icons/footer-mui/footer_logo2025.svg';

interface HelperTextProps {
  width?: number;
  height?: number;
}

export default function FooterLogo(props: HelperTextProps) {
  const { width, height } = props;
    return (
      <>
        <img src={FooterLogoIcon} useMap="#image-map" alt='Footer Logo' width={width} height={height} />
        <map name="image-map">
          <area target="_blank" alt="Excel Medical" title="Excel Medical" href="https://excelmedical.com/" coords="0,33,239,1" shape="rect" />
          <area target="_blank" alt="Male Excel" title="Male Excel" href="https://maleexcel.com/" coords="-1,60,113,35" shape="rect" />
          <area target="_blank" alt="Fem Excel" title="Fem Excel" href="https://femexcel.com/" coords="120,60,238,36" shape="rect" />
        </map>
      </>
    );
  }

FooterLogo.defaultProps = {
  width: 240,
  height: 61,
};
